import { SigninResponse, SigninUserPayload, loginUser } from "@/api/signin";
import { MutationOptionsWithoutFn } from "@/types/types";
import { useMutation } from "@tanstack/react-query";

export const useSignInUser = (
	options?: MutationOptionsWithoutFn<SigninResponse, SigninUserPayload>,
) => {
	return useMutation({
		mutationFn: loginUser,
		...options,
	});
};
